var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactInfoContentBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24C17.6 24 18.5417 23.6083 19.325 22.825C20.1083 22.0417 20.5 21.1 20.5 20C20.5 18.9 20.1083 17.9583 19.325 17.175C18.5417 16.3917 17.6 16 16.5 16C15.4 16 14.4583 16.3917 13.675 17.175C12.8917 17.9583 12.5 18.9 12.5 20C12.5 21.1 12.8917 22.0417 13.675 22.825C14.4583 23.6083 15.4 24 16.5 24ZM8.5 32H24.5V30.85C24.5 30.05 24.2833 29.3167 23.85 28.65C23.4167 27.9833 22.8167 27.4833 22.05 27.15C21.1833 26.7833 20.2917 26.5 19.375 26.3C18.4583 26.1 17.5 26 16.5 26C15.5 26 14.5417 26.1 13.625 26.3C12.7083 26.5 11.8167 26.7833 10.95 27.15C10.1833 27.4833 9.58333 27.9833 9.15 28.65C8.71667 29.3167 8.5 30.05 8.5 30.85V32ZM28.5 40H4.5C3.4 40 2.45833 39.6083 1.675 38.825C0.891667 38.0417 0.5 37.1 0.5 36V4C0.5 2.9 0.891667 1.95833 1.675 1.175C2.45833 0.391667 3.4 0 4.5 0H18.85C19.3833 0 19.8917 0.1 20.375 0.3C20.8583 0.5 21.2833 0.783333 21.65 1.15L31.35 10.85C31.7167 11.2167 32 11.6417 32.2 12.125C32.4 12.6083 32.5 13.1167 32.5 13.65V36C32.5 37.1 32.1083 38.0417 31.325 38.825C30.5417 39.6083 29.6 40 28.5 40Z",
    fill: "#467077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfoContentBlockIcon);
export default __webpack_public_path__ + "static/media/contact-info-content-block-icon.4d69c135f9fdbb9f858781001a287e7d.svg";
export { ForwardRef as ReactComponent };